import React from 'react';
import styled from 'styled-components';
import { LabelItem } from './LabelItem';
import { InputProps } from 'reactstrap';
import { InputStyled } from './InputStyled';
import theme from '../../assets/css/theme';
// @ts-ignore
import chevron from '../../assets/img/icons/icon-chevron-down.svg';
// @ts-ignore
import chevronBlack from '../../assets/img/icons/icon-chevron-down-black.svg';

interface IWrapper {
  isInline: boolean;
  margin?: string;
}

const Wrapper = styled.div<IWrapper>`
  display: ${(props) => (props.isInline ? 'flex' : 'block')};
  margin: ${(props) => props.margin || '0 0 10px 0'};
  min-width: 200px;
`;

const SelectControl = styled.div`
  position: relative;
`;

const ChevronImage = styled.img`
  position: absolute;
  top: 50%;
  right: 19px;
  width: 20px;
  height: 20px;
  pointer-events: none;
  transform: translateY(-50%);
`;

const SelectStyled = styled(InputStyled)<{ $newDesign?: boolean }>`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  ${(props) =>
    props.$newDesign
      ? `background-image: none !important;
        background-color: ${theme.formsColors.mainBackground};
        height: 44px;
        border-radius: 22px;
        padding-right: 56px;

        &:disabled {
          background-color: ${theme.formsColors.mainBackground};
          opacity: 1;
        }`
      : `background: url(${chevron}) 95.5% center no-repeat;
        background-size: 12px;`}
`;

interface IProps extends InputProps {
  options: any[];
  label?: string;
  id?: string;
  isInline?: boolean;
  changeCallback: (value: string) => void;
  value: string | number;
  defaultOptionsText?: string;
  margin?: string;
  formTheme?: string;
  isDefaultDisabled?: boolean;
  required?: boolean;
  labelActions?: any;
  /** Opts into the redesigned 20px black chevron inset 19px from the right. */
  newDesign?: boolean;
}

export const SelectItem = ({
  options = [],
  label,
  id,
  isInline = false,
  changeCallback,
  value,
  defaultOptionsText,
  margin,
  isDefaultDisabled,
  wrapperStyle = {},
  labelActions,
  required,
  newDesign,
  ...props
}: IProps) => {
  const showLabel = label ? (
    <LabelItem htmlFor={id} isSmall isBold>
      {label}
      {required && '*'}
    </LabelItem>
  ) : null;
  const defaultOption = defaultOptionsText ? (
    <option value="" aria-selected={false} disabled={isDefaultDisabled}>
      {' '}
      {defaultOptionsText}
    </option>
  ) : null;
  const changeHandler = (e: React.BaseSyntheticEvent) => changeCallback(e.currentTarget.value);

  return (
    <Wrapper isInline={isInline} margin={margin} style={wrapperStyle}>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ paddingRight: '15px' }}
      >
        <div>{showLabel}</div>
        <div>{labelActions}</div>
      </div>
      <SelectControl>
        <SelectStyled
          type="select"
          onChange={changeHandler}
          value={value}
          $newDesign={newDesign}
          {...props}
        >
          {defaultOption}
          {options.map((option, key) => (
            <option
              key={key}
              value={option.value}
              aria-selected
              style={option.style}
              disabled={Boolean(option.isDisabled)}
            >
              {option.text}
            </option>
          ))}
        </SelectStyled>
        {newDesign && <ChevronImage src={chevronBlack} alt="" aria-hidden />}
      </SelectControl>
    </Wrapper>
  );
};

export default SelectItem;
